module.exports = __webpack_public_path__ + "static/img/3fe9e08449df3672ddd35320145e80c4.partners2.1709800931122.png";